"use client";

import { SwiperSlide } from "swiper/react";
import SwiperCarousel from "@/components/plugins/swiper/SwiperCarousel";
import TextHeader from "@/components/typography/TextHeader";
import TextContent from "@/components/typography/TextContent";
import Image from "next/image";
import TextSubHeader from "@/components/typography/TextSubHeader";
import SwiperSlideBookingTestimonial from "@/components/plugins/swiper/SwiperSlideBookingTestimonial";
import imgCountryPoland from "@/assets/images/screens/homepage/brand-country-poland.svg";
import imgLogoBookingIcon from "@/assets/images/logo/booking-icon.svg";
import imgLogoBooking from "@/assets/images/logo/booking.svg";
import imgLogoGoogle from "@/assets/images/logo/google.svg";
import imgLogoFacebook from "@/assets/images/logo/facebook.svg";
import imgRating from "@/assets/images/screens/homepage/brand-rating.svg";
import TextDisclaimer from "@/components/typography/TextDisclaimer";
import Logo from "@/components/images/Logo";
import { TestimonialType } from "@/types/TestimonialType";

export default function BrandPros() {
  const testimonials: Array<TestimonialType> = [
    {
      name: "Michał",
      nameColor: "bg-[#FF0032]",
      countryIcon: imgCountryPoland,
      countryName: "Polska",
      rating: "10",
      header: "Wyjątkowy",
      content:
        "Znakomity hotel, obsługa na najwyższym poziomie, kucharz - brak słów, tak wyśmienitych posiłków dawno nie jadłem. Pokoje w sam raz, z pięknym widokiem, przestronne i dobrze wyposażone, zaprojektowane z gustem  👌🏻 Można się zakochać i polecać 🔥",
    },
    {
      name: "Irina",
      nameColor: "bg-[#619B66]",
      countryIcon: imgCountryPoland,
      countryName: "Polska",
      rating: "10",
      header: "Wyjątkowy",
      content:
        "Obiekt zasługuje na 11 punktów, gdyby było to możliwe 😊 Wszystko przemyślane w najmniejszych szczegółach. Personel bardzo pomocny i sympatyczny. Śniadania – na każdy gust i wiek. Nieskazitelna czystość. Polecam każdemu o każdej porze roku.",
    },
    {
      name: "Piotr",
      nameColor: "bg-[#0011C9]",
      countryIcon: imgCountryPoland,
      countryName: "Polska",
      rating: "10",
      header: "Wyjątkowy",
      content:
        "Bardzo dobra lokalizacja. Piękne położenie hotelu ze wspaniałymi widokami. Duże, przestronne apartamenty, nowocześnie i bogato wyposażone. Czysto i cicho. Troskliwy i uprzejmy personel. Łatwo dostępny i duży parking, zarówno naziemny, jak i podziemny. Bardzo smaczne i aż za obfite posiłki.",
    },
  ];

  return (
    <div
      className="bg-[#F8F7FA] pb-16 pt-16 lg:pb-24 lg:pt-24"
      id={"brand-pros"}
    >
      <div className="mb-12 lg:mb-16">
        <div className="m-auto max-w-screen-sm px-5">
          <div className="relative z-10">
            <TextHeader>Poznaj markę</TextHeader>
            <Logo className="mb-5 w-48 lg:w-72" inverse={true} />
            <TextContent>
              Inwestycja w Szczyrku to kolejny projekt brandu Tremonti®.
              Debiutujący kilka lat temu Tremonti® Hotel w Karpaczu zyskał
              uznanie gości i wysokie obłożenie niezależnie od sezonu – ten
              sukces chcemy powtórzyć.
            </TextContent>
          </div>
        </div>
      </div>
      <div className="mb-16 lg:mb-24">
        <SwiperCarousel>
          {testimonials.map((testimonial, index) => (
            <SwiperSlide className="flex h-[initial]" key={index}>
              <SwiperSlideBookingTestimonial {...testimonial} />
            </SwiperSlide>
          ))}
        </SwiperCarousel>
        <div className="relative m-auto max-w-screen-lg px-5 lg:px-0">
          <div className="absolute bottom-2.5 flex items-center lg:bottom-6">
            <Image src={imgLogoBookingIcon} alt={""} className="mr-2.5" />
            <TextDisclaimer>Żródło Booking.com</TextDisclaimer>
          </div>
        </div>
      </div>
      <div>
        <div className="m-auto max-w-screen-sm px-5">
          <TextSubHeader className="!mb-12 lg:!mb-14">
            Tremonti® to popularny i rozpoznawalny brand, ceniony za wysoką
            jakość usług, komfortowy pobyt i profesjonalną obsługę.
          </TextSubHeader>
          <div className="grid grid-cols-2 gap-5 lg:grid-cols-3 lg:gap-7">
            <div className="flex h-44 flex-col items-center justify-center bg-white">
              <div className="mb-2.5 flex h-9 items-center">
                <Image src={imgLogoBooking} alt={""} />
              </div>
              <div>
                <div className="flex h-20 w-20 items-center justify-center rounded-full bg-[#D9B975] text-[40px]/[46px] text-white">
                  9,1
                </div>
              </div>
            </div>
            <div className="flex h-44 flex-col items-center justify-center bg-white">
              <div className="flex h-9 items-center">
                <Image src={imgLogoGoogle} alt={""} />
              </div>
              <div className="flex flex-col items-center">
                <div className="my-3 text-[40px]/[46px] font-bold">4.7</div>
                <div>
                  <Image src={imgRating} alt={""} />
                </div>
              </div>
            </div>
            <div className="flex h-44 flex-col items-center justify-center bg-white">
              <div className="flex h-9 items-center">
                <Image src={imgLogoFacebook} alt={""} />
              </div>
              <div className="flex flex-col items-center">
                <div className="my-3 text-[40px]/[46px] font-bold">4.7</div>
                <div>
                  <Image src={imgRating} alt={""} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
